import { useState } from "react";
import { apiUrl, setAuthSession } from "./api";

const allowedUsers = [
  "ifeoluwa.o@globusafriventures.com",
  "paschal.a@globusafriventures.com",
  "kandarp.g@globusafriventures.com",
  "radhey.g@globusafriventures.com",
  "accounts@globusafriventures.com",
  "info@globusafriventures.com",
  "temitope.a@globusafriventures.com"
];

function Login({ onLogin }) {
  const [mode, setMode] = useState("login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [setupCode, setSetupCode] = useState("");
  const [message, setMessage] = useState("");

  function submitLogin() {
    fetch(apiUrl("/api/auth/login"), {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ email, password })
    })
      .then(async res => {
        const data = await res.json();
        if (!res.ok) {
          throw new Error(data.detail || "Login failed");
        }
        return data;
      })
      .then(data => {
        setAuthSession(data);
        onLogin(data);
      })
      .catch(err => setMessage(err.message));
  }

  function submitSetup() {
    fetch(apiUrl("/api/auth/setup-password"), {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        email,
        password,
        setup_code: setupCode
      })
    })
      .then(async res => {
        const data = await res.json();
        if (!res.ok) {
          throw new Error(data.detail || "Password setup failed");
        }
        return data;
      })
      .then(() => {
        setMessage("Password set. You can log in now.");
        setMode("login");
      })
      .catch(err => setMessage(err.message));
  }

  return (
    <div style={{ maxWidth: "420px", margin: "80px auto", padding: "20px" }}>
      <h2>ATC Dashboard Login</h2>

      <select
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        style={{ width: "100%", padding: "8px", marginBottom: "10px" }}
      >
        <option value="">Select GAVL ID</option>
        {allowedUsers.map(userEmail => (
          <option key={userEmail} value={userEmail}>
            {userEmail}
          </option>
        ))}
      </select>

      <input
        type="password"
        placeholder="Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        style={{ width: "100%", padding: "8px", marginBottom: "10px" }}
      />

      {mode === "setup" && (
        <input
          type="password"
          placeholder="Setup code, if configured"
          value={setupCode}
          onChange={(e) => setSetupCode(e.target.value)}
          style={{ width: "100%", padding: "8px", marginBottom: "10px" }}
        />
      )}

      <button
        onClick={mode === "login" ? submitLogin : submitSetup}
        disabled={!email || !password}
      >
        {mode === "login" ? "Login" : "Set Password"}
      </button>

      <button
        style={{ marginLeft: "10px" }}
        onClick={() => {
          setMessage("");
          setMode(mode === "login" ? "setup" : "login");
        }}
      >
        {mode === "login" ? "Set password" : "Back to login"}
      </button>

      {message && <p>{message}</p>}
    </div>
  );
}

export default Login;
